// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class UserAPI extends MainAPI {
	/**
	 * @param {*} userEmail
	 */
	async getLoggedInUser(userEmail) {
		return API.get(`${ENDPOINTS.GET_USER}/${userEmail}`);
	}
	/**
	 * @return {object} users details by userId
	 * @params queryParams
	 */
	async getUserDetails(userId) {
		return API.get(`${ENDPOINTS.GET_USER_BY_ID}/${userId}`);
	}
	/**
	 * @return {object} list of users
	 * @params queryParams
	 */
	async getUserList(queryParams) {
		return API.get(`${ENDPOINTS.GET_USER}?${queryString.stringify(queryParams)}`);
	}
	/**
	 * @return {status} 204 No Response
	 * @param {object} userData
	 * */
	async postAdminUser(userData) {
		return API.post(ENDPOINTS.POST_ADMIN_USER, userData);
	}

	/**
	 * @return 204
	 * @params userId
	 */
	async updateUserStatus(userId, userDetails) {
		return API.put(`${ENDPOINTS.PUT_USER}/${userId}/status`, userDetails);
	}

	/**
	 * @return {object} 
	 * @param {object} queryParams
	 **/
	async getCustomer(queryParams) {
		return API.get(`${ENDPOINTS.GET_CUSTOMER}?${queryString.stringify(queryParams)}`);
	}
	
	/**
	* @param {*} emailAddress
	*/
	async resendLink(emailAddress) {
		return API.put(`${ENDPOINTS.PUT_USER}/${emailAddress}/activation-link`);
	}

	/**
	 * @return {object} users details by userId
	 * @params queryParams
	 */
	async getUserWalkerSitterDetails(userId) {
		return API.get(`/admin${ENDPOINTS.GET_USER_BY_ID}/${userId}/walker-sitter`);
	}

	async putWalkerSitterDetails(userId, walkerSitterDetails) {
		let newFormData = new FormData();

		const {formData, userImage} = walkerSitterDetails;
		
		newFormData.append('formData', JSON.stringify(formData));
		
		if (formData.user.isImageChanged) {
			newFormData.append('profileImage', userImage);
		}
		return API.put(`/admin${ENDPOINTS.GET_USER_BY_ID}/${userId}/walker-sitter`, newFormData);
	}

	/**
	 * Retrieves a list of store credits based on the provided query parameters.
	 *
	 * @async
	 * @function getStoreCreditList
	 * @param {Object} queryParams - The parameters to filter the store credit list.
	 * @returns {Promise<Object>} A promise that resolves to the list of store credits.
	 * @throws {Error} Throws an error if the request fails.
	 */
	async getStoreCreditList(queryParams) {
		return API.get(`/admin/store-credit/list?${queryString.stringify(queryParams)}`);
	}

	/**
	 * Retrieves the store credit history for a specific user.
	 *
	 * @async
	 * @function getUserStoreCreditHistory
	 * @param {string} userId - The ID of the user whose store credit history will be fetched.
	 * @returns {Promise<Object>} A promise that resolves to the store credit history.
	 * @throws {Error} Throws an error if the request fails.
	 */
	async getUserStoreCreditHistory(userId) {
		return API.get(`${ENDPOINTS.GET_USER_STORE_CREDIT_HISTORY}/${userId}`);
	}

	async getUserNotesAndReminders(userId) {
		return API.get(`${ENDPOINTS.GET_USER_NOTES_AND_REMINDERS}/user-notes-reminders/${userId}`);
	}
	async addUserNoteAndReminder(userId, noteReminderDetails) {
		return API.post(`${ENDPOINTS.GET_USER_NOTES_AND_REMINDERS}/user-notes-reminders/${userId}`, noteReminderDetails);
	}
}

export default new UserAPI();